import type {
  AlgorithmConfig,
  ApiResponse,
  ConfigGetRequest,
  Task,
  TaskAbilitiesResult,
} from "@/features/login/types";
import { apiClient } from "@/services/api";

export const algorithmService = {
  getTaskList: async (): Promise<Task[]> => {
    const { data } = await apiClient.post<ApiResponse<Task[]>>("/tasks/list");

    if (data.code !== 0)
      throw new Error(data.msg || "Failed to fetch task list");

    return data.result;
  },

  getTaskAbilities: async (): Promise<TaskAbilitiesResult> => {
    const { data } =
      await apiClient.get<ApiResponse<TaskAbilitiesResult>>("/tasks/abilities");
    if (data.code !== 0)
      throw new Error(data.msg || "Failed to fetch task abilities");
    return data.result;
  },
  getTaskParameter: async (taskId: string): Promise<AlgorithmConfig> => {
    const { data } = await apiClient.post<{ result: AlgorithmConfig }>(
      `/task-parameter/get`,
      { taskId },
    );
    return data.result;
  },

  modifyTaskParameter: async (
    genieId: string,
    payload: Record<string, unknown>,
  ): Promise<AlgorithmConfig> => {
    const { data } = await apiClient.post<{ result: AlgorithmConfig }>(
      `/api/task-parameter/${genieId}/mod`,
      payload,
    );
    return data.result;
  },
  getConfig: async (taskId: string): Promise<AlgorithmConfig> => {
    const payload: ConfigGetRequest = { taskId };
    const { data } = await apiClient.post<ApiResponse<AlgorithmConfig>>(
      "task-parameter/get",
      payload,
    );
    if (data.code !== 0) throw new Error(data.msg || "Failed to fetch config");
    return data.result;
  },
};
